// extracted by mini-css-extract-plugin
module.exports = {"section":"OptionNotes_section__DtpBM","notesList":"OptionNotes_notesList__gsZfv","noteItem":"OptionNotes_noteItem__2NfX0"};